export default __webpack_public_path__ + "static/media/node-js-icon.10354602.svg";